export enum AuthStorageKey {
  VERIFICATION_MAIL = 'verifyemail',
  VERIFICATION_MOBILE = 'verifymobile',
  VERIFICATION_MOBILE_DATA = 'verifyMotp',
  VERIFICATION_EMAIL_DATA = 'verifyotp',
}
